import WINDOW from "../../../utils/window";
import onResize from "./on-resize";
import onResizeMutation from "./on-resize-mutation";
import onVisibilityChange from "./on-visibility-change";

const setGlobalListeners = () => {
  const listeners = /** @type {WindowListenersProps} */ (
    WINDOW.get("listeners")
  );

  const observers = /** @type {WindowObserverProps} */ (
    WINDOW.get("observers")
  );

  if (!listeners.get("resize")) {
    listeners.set("resize", onResize);
    window.addEventListener("resize", onResize);
  }

  if (!listeners.get("visibilitychange")) {
    listeners.set("visibilitychange", onVisibilityChange);
    document.addEventListener("visibilitychange", onVisibilityChange);
  }

  if (!observers.get("resize")) {
    onResizeMutation(observers);
  }
};

export default setGlobalListeners;
